module.exports = __webpack_public_path__ + "f4e2f8a70fa775b4128734f08170ec7e.svg";